import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';
import bulletLinkManifest from '../../bullet-link/manifest.json';

domReady(async () => {
	const { blockJsClass } = manifest;

	const elements = document.querySelectorAll(`.${blockJsClass}`);
	const accordionTriggerSelector = `${blockJsClass}-accordion-trigger`;
	const bulletLinkSelector = `${bulletLinkManifest.blockJsClass}`;

	if (!elements.length) {
		return;
	}

	const { BulletLinksAcccordion } = await import('./bullet-links-accordion');

	[...elements].forEach((element) => {
		const bulletLinksAccordion = new BulletLinksAcccordion({
			element,
			accordionTriggerSelector,
			bulletLinkSelector,
		});

		bulletLinksAccordion.init();
	});
});
